import { useEffect } from 'react';
import { useTheme } from './useTheme';

export function ThemeSync() {
  const { mode, colorTheme } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const apply = () => {
      const effective =
        mode === 'auto'
          ? window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light'
          : mode;
      root.setAttribute('data-theme', effective);
      root.setAttribute('data-color', colorTheme);
    };
    apply();
    if (mode === 'auto') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [mode, colorTheme]);

  return null;
}
